import { render, staticRenderFns } from "./KernelBoxTypes.vue?vue&type=template&id=381f4894&"
import script from "./KernelBoxTypes.vue?vue&type=script&lang=js&"
export * from "./KernelBoxTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports